export default __webpack_public_path__ + "images/SB.83354f5.png";